import React from 'react'
import styled from 'styled-components'
import {
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  Row,
  Col,
} from 'reactstrap'
import get from 'lodash/get'
import { statusColor } from '../helpers/color'
import { FONTS, COLORS } from '../../../constants'

export const Compensate = (props) => {
  const data = get(props, 'data', [])

  return (
    <Modal
      isOpen={ get(props, 'showDetail') }
      toggle={ get(props, 'handleDetail') }
    >
      <ModalHeader toggle={ get(props, 'handleDetail') }>
        <Header>
          Compensate Request
        </Header>
      </ModalHeader>
      <ModalBody style={ { overflowY: 'auto', height: '500px' } }>
        <LabelTextInfo>Employee Name</LabelTextInfo>
        <Row>
          <Col>
            <TextInfo>{ get(data[0], 'name', '-') }</TextInfo>
          </Col>
        </Row>
        <LabelTextInfo>Project Name</LabelTextInfo>
        <Row>
          <Col>
            <TextInfo>{ get(data[0], 'project', '-') }</TextInfo>
          </Col>
        </Row>
        <LabelTextInfo>Compensate Date</LabelTextInfo>
        <Row >
          <Col>
            <TextInfo>{ get(data[0], 'start_date', '') } - { get(data[0], 'end_date', '') }</TextInfo>
          </Col>
        </Row>
        <LabelTextInfo>Working Time</LabelTextInfo>
        <Row >
          <Col>
            <TextInfo>{ get(data[0], 'working_time', '-') }</TextInfo>
          </Col>
        </Row>
        <LabelTextInfo>Approver</LabelTextInfo>
        <Row >
          <Col>
            <TextInfo>{ get(data[0], 'approver', '-') }</TextInfo>
          </Col>
        </Row>
        { get(data[0], 'status', '') !== '' &&
          <div>
            <LabelTextInfo>Status</LabelTextInfo>
            <Row>
              <Col>
                <span style={ { color: statusColor(get(data[0], 'status', '')), fontWeight: 'bold' } }>
                  <TextInfo>{ get(data[0], 'status', '-') }</TextInfo>
                </span>
              </Col>
            </Row>
          </div>
        }
        { get(data[0], 'remark_request_user', '') !== '' &&
          <div>
            <LabelTextInfo>Remarks</LabelTextInfo>
            <Row>
              <Col>
                <TextInfo>{ get(data[0], 'remark_request_user', '-') }</TextInfo>
              </Col>
            </Row>
          </div>
        }
        { get(data[0], 'remark_approver', '') !== '' &&
          <div>
            <LabelTextInfo>Approver Remarks</LabelTextInfo>
            <Row>
              <Col>
                <TextInfo>{ get(data[0], 'remark_approver', '-') }</TextInfo>
              </Col>
            </Row>
          </div>
        }
        { get(data[0], 'remark_hr', '') !== '' &&
          <div>
            <LabelTextInfo>Cancel Remarks</LabelTextInfo>
            <Row>
              <Col>
                <TextInfo>{ get(data[0], 'remark_hr', '-') }</TextInfo>
              </Col>
            </Row>
          </div>
        }
        { data.length > 1 &&
        <div>
          <DropdownItem divider />
          <LabelTextInfo>Employee Name</LabelTextInfo>
          <Row>
            <Col>
              <TextInfo>{ get(data[1], 'name', '-') }</TextInfo>
            </Col>
          </Row>
          <LabelTextInfo>Project Name</LabelTextInfo>
          <Row>
            <Col>
              <TextInfo>{ get(data[1], 'project', '-') }</TextInfo>
            </Col>
          </Row>
          <LabelTextInfo>Compensate Date</LabelTextInfo>
          <Row>
            <Col>
              <TextInfo>{ get(data[1], 'start_date', '') } - { get(data[1], 'end_date', '') }</TextInfo>
            </Col>
          </Row>
          <LabelTextInfo>Working Time</LabelTextInfo>
          <Row >
            <Col>
              <TextInfo>{ get(data[1], 'working_time', '-') }</TextInfo>
            </Col>
          </Row>
          <LabelTextInfo>Approver</LabelTextInfo>
          <Row >
            <Col>
              <TextInfo>{ get(data[1], 'approver', '-') }</TextInfo>
            </Col>
          </Row>
          { get(data[1], 'status', '') !== '' &&
            <div>
              <LabelTextInfo>Status</LabelTextInfo>
              <Row>
                <Col>
                  <span style={ { color: statusColor(get(data[1], 'status', '')), fontWeight: 'bold' } }>
                    <TextInfo>{ get(data[1], 'status', '-') }</TextInfo>
                  </span>
                </Col>
              </Row>
            </div>
          }
          { get(data[1], 'remark_request_user', '') !== '' &&
            <div>
              <LabelTextInfo>Remarks</LabelTextInfo>
              <Row>
                <Col>
                  <TextInfo>{ get(data[1], 'remark_request_user', '-') }</TextInfo>
                </Col>
              </Row>
            </div>
          }
          { get(data[1], 'remark_approver', '') !== '' &&
            <div>
              <LabelTextInfo>Approver Remarks</LabelTextInfo>
              <Row>
                <Col>
                  <TextInfo>{ get(data[1], 'remark_approver', '-') }</TextInfo>
                </Col>
              </Row>
            </div>
          }
          { get(data[1], 'remark_hr', '') !== '' &&
            <div>
              <LabelTextInfo>Cancel Remarks</LabelTextInfo>
              <Row>
                <Col>
                  <TextInfo>{ get(data[1], 'remark_hr', '-') }</TextInfo>
                </Col>
              </Row>
            </div>
          }
        </div>
        }
      </ModalBody>
    </Modal>
  )
}

const LabelTextInfo = styled(Label)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.NORMAL_SIZE};
  margin-bottom: 0px;
`
const Header = styled(Label)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.TITLE_SIZE};
  color: ${COLORS.PRIMARY_RED};
`
const TextInfo = styled(Label)`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.NORMAL_SIZE};
`



// WEBPACK FOOTER //
// ./src/components/timesheet/form/show-compensate.js